document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector('[data-main-product-image]');
      if (!target) return;
      target.src = button.dataset.src;
      target.alt = button.dataset.alt || '';
    });
  });
});
